import React from 'react';
import PropTypes from 'prop-types';
import NextImage from 'next/image';
import { Tooltip } from '@web/atoms/Tooltip';
import {
  Card,
  Info,
  StyledImage,
  Name,
  Description,
  CardContent,
  CardHeader,
} from './styles.js';

export const ActivityCard = ({
  label,
  title,
  description,
  checked = false,
  img,
  onChange,
  unavailable,
  unavailableText,
  notSelectable,
  notSelectableText = 'To choose this item, please remove one of your previous selections.',
  level,
}) => {
  const getActivityCard = props => (
    <Card
      {...props}
      checked={checked}
      unavailable={unavailable}
      $notSelectable={notSelectable}
      aria-label={`${label} ${title}`}
      onClick={!notSelectable && onChange}
    >
      <CardContent>
        <StyledImage checked={checked} unavailable={unavailable}>
          <NextImage src={img.src} alt={img.alt} width={82} height={82} />
        </StyledImage>
        <Info>
          <CardHeader>
            <Name as={level}>{title}</Name>
          </CardHeader>
          <Description>
            {unavailable ? unavailableText : description}
          </Description>
        </Info>
      </CardContent>
    </Card>
  );

  return (notSelectable && !unavailable) || unavailable ? (
    <Tooltip trigger={getActivityCard} placement="top" offsetY={-200}>
      {notSelectableText}
    </Tooltip>
  ) : (
    getActivityCard()
  );
};

ActivityCard.displayName = 'ActivityCard';
ActivityCard.propTypes = {
  label: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  unavailable: PropTypes.bool,
  unavailableText: PropTypes.string,
  unavailableLabel: PropTypes.string,
  notSelectable: PropTypes.bool,
  notSelectableText: PropTypes.string,
  description: PropTypes.node.isRequired,
  checked: PropTypes.bool,
  img: PropTypes.shape({
    src: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  level: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']),
};
